import { NgxMaskDirective } from 'ngx-mask';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';

import { UiModule } from '@lockton-apps/shared/ui/lui';
import { MatIconModule } from '@angular/material/icon';
import { TextareaFieldTypeComponent } from './textarea-field-type.component';
import { DynamicTextareaDirective } from '@lockton-apps/shared/util/form-utils';

@NgModule({
  declarations: [TextareaFieldTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMaskDirective,

    FormlyModule.forChild({
      types: [
        {
          name: 'textarea',
          component: TextareaFieldTypeComponent,
          wrappers: ['mat-form-field', 'addons'],
        },
      ],
    }),
    UiModule,
    MatIconModule,
    DynamicTextareaDirective,
  ],
})
export class TextareaFieldTypeModule {}
